export const tangoLogo = "/Tango_TM_logo-White.svg";
